import EnhancedQuiz from "th/enhancedQuiz";

export { EnhancedQuiz };

customElements.define(
  "th-enhanced-quiz",
  EnhancedQuiz.CustomElementConstructor
);
